module.exports = __webpack_public_path__ + "img/undraw-security.975dc9c1.svg";